import { useState, useEffect } from 'react'

interface PaginationProps {
  totalCount: number
  onPageChange?: (page: number) => void
  paramPage?: number
  isTotalPages?: boolean // 새로운 prop: totalCount가 페이지 수인지 아이템 수인지 구분
  boardType?: 'promotion' | 'blog' | 'normal'
}

const Pagination: React.FC<PaginationProps> = ({
  totalCount,
  onPageChange,
  paramPage,
  isTotalPages = false, // 기본값은 false (아이템 수)
  boardType,
}) => {
  //const perPage = isPromotion ? 6 : 10
  const perPage = boardType === 'promotion' ? 6 : boardType === 'blog' ? 12 : 10 // 기본값: 일반
  const [currentPage, setCurrentPage] = useState(paramPage || 1)

  // paramPage가 변경될 때마다 currentPage 업데이트
  useEffect(() => {
    setCurrentPage(paramPage || 1)
    window.scrollTo(0, 0)
  }, [paramPage])
  // 페이지 수 계산
  const totalPage = isTotalPages
    ? totalCount // totalCount가 이미 페이지 수인 경우
    : Math.ceil(totalCount / perPage) // totalCount가 아이템 수인 경우

  const handlePageClick = (page: number) => {
    if (page >= 1 && page <= totalPage) {
      // totalPage와 비교하도록 수정
      setCurrentPage(page)
      onPageChange?.(page)
    }
  }

  // 페이지가 없으면 렌더링하지 않음
  // if (totalPage <= 1) {
  //   return null
  // }

  if (totalCount === 0) {
    return null // 데이터가 아예 없을 때만 안 보여줌
  }

  return (
    <div style={{ position: 'relative' }}>
      <div style={styles.pagination}>
        {/* Previous button */}
        <button
          style={{
            ...styles.button,
            ...(currentPage === 1 ? styles.disabledButton : {}),
          }}
          onClick={() => handlePageClick(currentPage - 1)}
          disabled={currentPage === 1}
        >
          «
        </button>

        {Array.from({ length: totalPage }, (_, index) => (
          <button
            key={index + 1}
            style={{
              ...styles.button,
              ...(currentPage === index + 1 ? styles.activeButton : {}),
            }}
            onClick={() => handlePageClick(index + 1)}
          >
            {index + 1}
          </button>
        ))}

        <button
          style={{
            ...styles.button,
            ...(currentPage === totalPage ? styles.disabledButton : {}),
          }}
          onClick={() => handlePageClick(currentPage + 1)}
          disabled={currentPage === totalPage}
        >
          »
        </button>
      </div>

      {/* 디버깅용 정보 (개발 환경에서만 표시) */}
      {/* {process.env.NODE_ENV === 'development' && (
        <div
          style={{
            textAlign: 'center',
            marginTop: '10px',
            fontSize: '12px',
            color: '#666',
          }}
        >
          현재: {currentPage} / 전체페이지: {totalPage} / totalCount:{' '}
          {totalCount} / perPage: {perPage}
        </div>
      )} */}
    </div>
  )
}

const styles = {
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    marginTop: '20px',
  },
  button: {
    padding: '10px 15px',
    fontSize: '16px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    backgroundColor: 'white',
    cursor: 'pointer',
    transition: 'all 0.3s',
  },
  activeButton: {
    backgroundColor: '#d09d30',
    color: 'white',
    fontWeight: 'bold',
  },
  disabledButton: {
    backgroundColor: '#f5f5f5',
    color: '#ccc',
    cursor: 'not-allowed',
  },
}

export default Pagination
